export const POPOVER_TITLE = {
  CHECKED: 'Share Investment Amount',
  UNCHECKED: 'Share without Investment Amount',
};

export const TOOLTIP_TITLE = 'Investment amount will be displayed along with price if you turn the toggle on.';
